// @flow
import { Provider, useDispatch } from 'react-redux';

import { linkButton } from '@styles/buttons';

import { searchPath } from '@src/app_routes/settings';

type TProps = {
  diamondId: number
};

function AddDiamondToSettingLink({ diamondId }: TProps) {
  const dispatch = useDispatch();
  const onLinkClick = () => {
    dispatch({
      type: 'SELECT_DYOR_SETTING_SKU_AND_DIAMOND_ID',
      payload: { diamondId: diamondId, settingSku: 'CLEAR' },
      redirectTo: searchPath()
    });
  };

  return (
    <div style={{ marginTop: 20 }}>
      <button style={linkButton} onClick={onLinkClick}>
        Place this diamond in a setting
      </button>
    </div>
  );
}

export default (props: TProps) => {
  const store = ReactOnRails.getStore('SharedReduxStore');

  return (
    <Provider store={store}>
      <AddDiamondToSettingLink {...props} />
    </Provider>
  );
};
